import { Pencil } from 'lucide-react'

interface UserTableActionsProps {
    onEdit?: (userId: number) => void
}

export default function UserTableActions({ onEdit }: UserTableActionsProps) {
    return (
        <div className="flex justify-center gap-2">
            <button
                onClick={() => onEdit?.(0)}
                className="p-1 hover:bg-gray-100 rounded transition-colors"
                aria-label="Editar usuario"
            >
                <Pencil size={20} className="text-gray-600" />
            </button>
        </div>
    )
}
